import { useRouter } from 'next/router'
import { Button, IconArrowRightDefault } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import Image from 'components/LegacyImage'
import { trackLearnMoreClicked } from './events'

const LearnMore = ({
  path,
  onClick,
}: {
  path: string
  onClick: () => void
}) => {
  const { t } = useTranslation('@mc/next')
  const router = useRouter()

  return (
    <div>
      <Button
        className='mc-p-3'
        kind='play'
        as='a'
        onClick={() => {
          onClick()
          router.push(path)
        }}
      >
        {t('forBusiness.learnMore')}
        <IconArrowRightDefault className='mc-ml-2' />
      </Button>
    </div>
  )
}

const CardTitle = ({ children }: { children: string }) => (
  <h1 className='mc-text-color--tint mc-text--bold mc-text-large mc-mt-8 mc-mb-2'>
    {children}
  </h1>
)

const CardLabel = ({ children }: { children: string }) => (
  <div className='mc-text-h2'>{children}</div>
)

const ExploreCard = ({ children }: { children: React.ReactNode }) => (
  <div className='d-flex flex-column flex-1 mc-bg-container-tint-dark mc-corners--md mc-p-8'>
    {children}
  </div>
)

export const ExploreCards = () => {
  const { t } = useTranslation('@mc/next')

  return (
    <>
      <ExploreCard>
        <div className='flex-1'>
          <Image
            className='mc-corners--lg'
            src='https://static.masterclass.com/catalog-plus.png'
            height={300}
            width={528}
          />
          <CardTitle>
            {t('forBusiness.exploreCardsSection.collectiveTitle')}
          </CardTitle>
          <CardLabel>
            {t('forBusiness.exploreCardsSection.collectiveTarget')}
          </CardLabel>
          <ul className='mc-pl-6 mc-my-7' style={{ listStyle: 'disc' }}>
            <li className='mc-mb-4'>
              {t('forBusiness.exploreCardsSection.collectivePoint1')}
            </li>
            <li className='mc-mb-4'>
              {t('forBusiness.exploreCardsSection.collectivePoint2')}
            </li>
            <li className='mc-mb-4'>
              {t('forBusiness.exploreCardsSection.collectivePoint3')}
            </li>
          </ul>
        </div>
        <LearnMore
          path={paths.enterpriseCollective}
          onClick={() => trackLearnMoreClicked({ action: 'collective' })}
        />
      </ExploreCard>
      <ExploreCard>
        <div className='flex-1'>
          <Image
            className='mc-corners--lg'
            src='https://static.masterclass.com/essentials.png'
            height={300}
            width={528}
          />
          <CardTitle>
            {t('forBusiness.exploreCardsSection.acceleratorTitle')}
          </CardTitle>
          <CardLabel>
            {t('forBusiness.exploreCardsSection.acceleratorTarget')}
          </CardLabel>
          <ul className='mc-pl-6 mc-my-6' style={{ listStyle: 'disc' }}>
            <li className='mc-mb-4'>
              {t('forBusiness.exploreCardsSection.acceleratorPoint1')}
            </li>
            <li className='mc-mb-4'>
              {t('forBusiness.exploreCardsSection.acceleratorPoint2')}
            </li>
            <li className='mc-mb-4'>
              {t('forBusiness.exploreCardsSection.acceleratorPoint3')}
            </li>
          </ul>
        </div>
        <LearnMore
          path={paths.enterpriseAccelerator}
          onClick={() => trackLearnMoreClicked({ action: 'accelerator' })}
        />
      </ExploreCard>
    </>
  )
}
